export default {
  kosovo: "kosovoo",
  ethiopia: "addis-ababa",
  afghanistan: "afghanistan",
};
